import './menu.css';
import ChangeThemeButton from '../theme/ChangeThemeButton';
import logo from '../../resources/images/harmonia.webp';

export default function Menu() {
    return (
        <header className="App-header">
            <nav id="mainMenu">
                <ul>
                    <li>
                        <img src={logo} alt='logo' id='logo'></img>
                    </li>
                    <li>
                        <a href='#whoWeAre'>
                            Quem Somos?
                        </a>
                    </li>
                    {/* <li>
                        <a href='#whoWeAre'>
                            Origem
                        </a>
                    </li>
                    <li>
                        <a href='#whoWeAre'>
                            Como funciona?
                        </a>
                    </li>
                    <li>
                        <a href='#whoWeAre'>
                            Como usar?
                        </a>
                    </li>
                    <li>
                        <a href='#whoWeAre'>
                            Precauções com o uso
                        </a>
                    </li>
                    <li>
                        <a href='#whoWeAre'>
                            O mais queridinho
                        </a>
                    </li>
                    <li>
                        <a href='#whoWeAre'>
                            Sugestões de blends
                        </a>
                    </li>
                    <li>
                        <a href='#whoWeAre'>
                            Contate-nos
                        </a>
                    </li> */}

                </ul>
            </nav>
            <ChangeThemeButton></ChangeThemeButton>
        </header>
    );
}